import { DateTime } from 'luxon'

export default function(date) {
  if (!date) return ''
  let givenDate = DateTime.fromISO(date).toFormat('DD tt')

  return givenDate
}
